import { Map, fromJS, List } from 'immutable';
import requestStatus from '../../constants/requestStatus'
import actionTypes from '../../actions/actionTypes';

const INIT_STATE  = Map({
    status: requestStatus.INITIALIZED,
    error: null,
    data: Map({
        items: Map(),
        order: List()
    })
})

const onRequest     = state             => state.set('status', requestStatus.REQUEST_PENDING)
                                            .set('error', Map())

const onError   = (state, action)   => state.set('status', requestStatus.REQUEST_ERROR)
                                            .setIn(['error','settings'], action.payload.errorMessage)

const onSuccess = (state, action)   => state.set('status', requestStatus.REQUEST_SUCCESS)
                                            .deleteIn(['error', 'settings'])
                                            .setIn(['data', 'order'], fromJS(action.payload.data.settings.order))
                                            .setIn(['data', 'items'], fromJS(action.payload.data.settings.items))

const settingsReducer = (state = INIT_STATE, action) => {
    switch(action.type) {
        case actionTypes.EVENTS_ALL_REQUEST:
            return onRequest(state, action)
        case actionTypes.EVENTS_ALL_SUCCESS:
            return onSuccess(state, action)
        case actionTypes.EVENTS_ALL_ERROR:
            return onError(state, action)
        default:
            return state
    }
}

export default settingsReducer